<template>
    <div class="or-admin-auth flex-column column-hor-center padding-top-50">
        <input class="input" type="password" v-model="password"  @keydown.enter="login"/>
        <p class="button hover-pointer hover-yellow" @click="login">Войти</p>
        <p class="error">{{error}}</p>
    </div>
</template>

<script>
import Axios from 'axios'
export default {
    data() {
        return {
            password: undefined,
            error: null,
            isLoginInProcess: false,
        }
    },
    methods: {
        login() {
            if (this.isLoginInProcess) return;
            this.isLoginInProcess = true;
            this.error = null,
            Axios.post ('/api/login', {
                password: this.password
            })
                .then(({data})=>{
                    if (data) {
                        this.$emit('successful')
                    } else {
                        this.error = 'Пароль неверный'
                        this.isLoginInProcess = false;
                    }
                }, () => {
                    this.isLoginInProcess = false;
                    this.error = 'Что-то пошло не так';
                })
        }
    }
}
</script>

<style scoped>
    .or-admin-auth {
        height: 100vh;
        width: 100vw;
        min-width: 1200px;
        /* max-width: 100%; */
        background-color: #1E1E1E;
        color: white;
    }
    .input {
        padding: 5px 10px;
        box-sizing: border-box;
        border-radius: 8px;
        outline: none;
        border: none;
        margin-bottom: 20px;
    }
    .button {
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 20px;
    }
    .error {
        font-size: 14px;
        line-height: 16px;
        color: rgba(240, 75, 25, 0.801);
    }
</style>